export default function createInteractionsMiddleware(fedopsLogger, options = {}) {
  return (/* store*/) => next => action => {
    const interaction = options[action.type];
    if (interaction) {
      fedopsLogger.interactionEnded(interaction);
    }
    return next(action);
  };
}
